import { ModuleWithProviders, NgModule } from '@angular/core';
import { ShareFilesDialogModule } from '@dntlab/share-files-dialog';
import {
  DevExtremeModule,
  DxButtonModule,
  DxDataGridModule,
  DxFileManagerModule,
  DxPopupModule,
  DxToolbarModule,
} from 'devextreme-angular';
import { SharedModule } from 'src/app/shared.module';
import { ViewsModule } from 'src/app/views/views.module';
import { PipesModule } from '../../common/pipes/pipes.module';
import { ActivitiesModule } from '../activities/activities.module';
import { DevPopUpModule } from '../dev-popup/dev-popup.module';
import { FileManagerAdapter } from './dntl-filemanager/filemanager-adapter/filemanager-adapter';
import { FileDetailsComponent } from './file-details/file-details.component';
import { FileHistoryComponent } from './file-history/file-history.component';
import { FileManagerService } from './file-manager.service';
import { FileManagerComponent } from './file-manager/file-manager.component';
import { FilesRootComponent } from './files-root.component';

@NgModule({
  imports: [
    SharedModule,
    DxFileManagerModule,
    DxButtonModule,
    DxToolbarModule,
    ShareFilesDialogModule,
    ViewsModule,
    DxPopupModule,
    DxDataGridModule,
    PipesModule,
    DevExtremeModule,
    ActivitiesModule,
    DevPopUpModule,
  ],
  declarations: [FilesRootComponent, FileDetailsComponent, FileHistoryComponent, FileManagerComponent],
})
export class FilesManagerModule {
  public static forRoot(): ModuleWithProviders<FilesManagerModule> {
    return {
      ngModule: FilesManagerModule,
      providers: [FileManagerAdapter, FileManagerService],
    };
  }
}
